import React from 'react'
import MaskedInput from 'react-text-mask'
export const CodigoCapituloFIeld = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '_',
        'S',
        /[0-9]/,
        /[0-9]/,
        'C',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default CodigoCapituloFIeld



// WEBPACK FOOTER //
// ./src/components/Fields/CodigoCapituloField.js